import { render } from "./TitledPage.vue?vue&type=template&id=9b514f2e&scoped=true"
import script from "./TitledPage.vue?vue&type=script&lang=js"
export * from "./TitledPage.vue?vue&type=script&lang=js"

import "./TitledPage.vue?vue&type=style&index=0&id=9b514f2e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9b514f2e"

export default script